module.exports = __webpack_public_path__ + "img/logo-white.29cd27db.jpg";